import { createElement } from 'react';
import { element, shape, string, bool, func } from 'prop-types';
import '../types/props.js';
import 'reakit/styled';
import 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import '../styled/space.js';
import '../styled/index.js';
import { b as _objectWithoutPropertiesLoose, c as _extends } from '../chunk-ad6ad343.js';
import 'polished';
import '../default/palette.js';
import 'reakit/Button';
import 'airbnb-prop-types';
import '../parseIcons.js';
import 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';
import '../Icon/styled.js';
import '../chunk-16546651.js';
import '../Set/styled.js';
import '../Set/index.js';
import { ActionButtons as ActionButtons$1 } from './styled.js';
import '../Spinner/styled.js';
import '../Spinner/index.js';
import { a as Button, b as buttonPropTypes } from '../chunk-68945c57.js';
import _omit from 'lodash/omit';

var ActionButtons = function ActionButtons(_ref) {
  var addonButtons = _ref.addonButtons,
      cancelProps = _ref.cancelProps,
      cancelText = _ref.cancelText,
      isLoading = _ref.isLoading,
      onClickSubmit = _ref.onClickSubmit,
      onClickCancel = _ref.onClickCancel,
      palette = _ref.palette,
      submitProps = _ref.submitProps,
      submitText = _ref.submitText,
      type = _ref.type,
      props = _objectWithoutPropertiesLoose(_ref, ["addonButtons", "cancelProps", "cancelText", "isLoading", "onClickSubmit", "onClickCancel", "palette", "submitProps", "submitText", "type"]);

  return createElement(ActionButtons$1, props, createElement(Button, _extends({
    onClick: onClickCancel
  }, cancelProps), cancelText), addonButtons, createElement(Button, _extends({
    isLoading: isLoading,
    onClick: onClickSubmit,
    palette: palette,
    type: type
  }, submitProps), submitText));
};

var actionButtonsPropTypes = {
  addonButtons: element,
  cancelProps: shape(_omit(buttonPropTypes, 'children')),
  cancelText: string,
  className: string,
  isLoading: bool,
  onClickSubmit: func,
  onClickCancel: func,
  palette: string,
  submitProps: shape(_omit(buttonPropTypes, 'children')),
  submitText: string,
  type: string
};
ActionButtons.propTypes = actionButtonsPropTypes;
var actionButtonsDefaultProps = {
  addonButtons: undefined,
  cancelProps: {},
  cancelText: 'Cancel',
  className: undefined,
  isLoading: false,
  onClickSubmit: undefined,
  onClickCancel: undefined,
  palette: 'primary',
  submitProps: {},
  submitText: 'Submit',
  type: 'submit'
};
ActionButtons.defaultProps = actionButtonsDefaultProps;
var C = ActionButtons;
export default C;
export { ActionButtons, actionButtonsDefaultProps, actionButtonsPropTypes };